module.exports = __webpack_public_path__ + "img/s_hristova.8ac0fd79.jpg";